<template>
  <stepper-layout
    :stepTitle="'Rental Complete!'"
    :stepIcon="'check_circle'"
  >
    <rental-info
      :payload="payload"
      :unitFeatures="unitFeatures"
      :promotionMonth="promotionMonth"
    />
    <v-layout column class="subheading my-4">
      <v-textarea
        data-testid="rental-complete-textarea"
        class="rental-complete-textarea pt-2"
        filled
        v-model="note"
        label="Add Ledger Note (optional)"
        hint="When you are finished, click 'Add Note' to save this note to this tenant's account."
      />
      <v-btn
        data-testid="rental-complete-add-note-btn"
        class="rental-complete-add-note-btn primary mt-1 mx-0 mb-4"
        small
        :loading="noteLoading"
        :disabled="!note"
        @click="addNote"
      >
        Add Note
      </v-btn>
      <span class="my-3">
        This rental has been processed successfully. You may add a ledger note for this rental in the field above,
        click "Close" to return to the application, or click "Disposition" if the call has ended and you are prepared
        to disposition.
      </span>
    </v-layout>
  </stepper-layout>
</template>

<script>
import RentalInfo from "@/components/rent-unit/partials/RentalInfo";
import StepperLayout from "@/layouts/StepperLayout";
import { mapState } from "vuex";

export default {
  props: {
    payload: {
      type: Object
    },
    promotionMonth: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      note: "",
      noteLoading: false
    };
  },

  methods: {
    addNote() {
      this.noteLoading = true;

      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.info.external_id,
        ledgerId: this.info.ledger_id,
        description: this.note,
        notify_store_manager: false
      };
      this.$store.dispatch("createLedgerNote", payload)
        .then(() => {
          this.noteLoading = false;
          this.$store.dispatch("handleSuccess", "Reservation note added!");
          this.note = "";
        })
        .catch(err => {
          this.noteLoading = false;
          this.$store.dispatch("handleError", err);
        });
    }
  },

  computed: {
    ...mapState({
      info: state => state.tenant.info,
      unit: state => state.facilities.unit,
      unitFeatures: state => state.facilities.unitFeatures
    })
  },

  components: {
    RentalInfo,
    StepperLayout
  }
};
</script>
